const footerSocialsEl = document.querySelector('.footer__socials');

const footerCopyrightEl = document.querySelector('.footer__copyright');

footerSocialsEl.style.display = 'none';

footerCopyrightEl.style.borderTop = 'var(--border-footer-style)';

// console.log(footerNavEl);
// console.log(footerSocialsEl);
